import { render } from "./BaseTooltip.vue?vue&type=template&id=04df63f0&scoped=true&ts=true"
import script from "./BaseTooltip.vue?vue&type=script&lang=ts"
export * from "./BaseTooltip.vue?vue&type=script&lang=ts"

import "./BaseTooltip.vue?vue&type=style&index=0&id=04df63f0&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.27_typescript@5.3.3__webpack@5.91.0_webpack-cli@5.1.4_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04df63f0"]])

export default __exports__